import type { ActivationFlowDefinition } from "../types";

export const firstExportClarityFlow: ActivationFlowDefinition = {
    id: "first_export_clarity",
    title: "Clean Up Recording Workflow",
    steps: [
        {
            id: "intro_editor",
            title: "Welcome to the editor",
            target: "[data-tour='editor-workspace-area']",
            placement: "center",
            spotlightPadding: 14,
            content:
                "In this quick demo, we'll clean up a recording using Edit for clarity.",
            advance: {
                type: "manual",
            },
        },
        {
            id: "click_edit_for_clarity",
            title: "Edit for clarity",
            target: "[data-tour='ai-tools-edit-for-clarity']",
            placement: "left",
            content:
                "Click Edit for clarity to automatically find filler words, retakes, and off-topic tangents.",
            preStepAction: "open_ai_tools_sidebar",
            advance: {
                type: "click",
                selector: "[data-tour='ai-tools-edit-for-clarity']",
            },
            autoAdvanceDelayMs: 500,
        },
        {
            id: "submit_clarity",
            title: "Choose intensity and submit",
            target: "[data-tour='clarity-submit']",
            placement: "left",
            content:
                "Select an intensity level, then click Submit to start analyzing your recording.",
            advance: {
                type: "click",
                selector: "[data-tour='clarity-submit']",
            },
            autoAdvanceDelayMs: 500,
        },
        {
            id: "review_clarity_edits",
            title: "Review suggested edits",
            target: "[data-tour='clarity-preview-panel']",
            placement: "left",
            spotlightPadding: 8,
            content:
                "Review the suggested edits, then click Accept all to apply them.",
            pendingTitle: "Analyzing your recording",
            pendingContent:
                "We're analyzing the transcript for filler words, retakes, and tangents. This may take a moment.",
            preStepAction: "open_edit_for_clarity_sidebar",
            advance: {
                type: "click",
                selector: "[data-tour='clarity-accept-all']",
            },
        },
        {
            id: "open_export_menu",
            title: "Export your recording",
            target: "[data-tour='editor-export-button']",
            placement: "bottom",
            content: "Click Export to open export settings.",
            advance: {
                type: "click",
                selector: "[data-tour='editor-export-button']",
            },
        },
        {
            id: "start_export",
            title: "Start export",
            target: "[data-tour='export-card-submit']",
            placement: "left",
            content: "Click Export to render your cleaned-up recording.",
            advance: {
                type: "click",
                selector: "[data-tour='export-card-submit']",
            },
        },
    ],
};
